import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import CheckCircle from '../CheckCircle'
import styled from 'styled-components'

import { Col, Panel, Row } from 'react-bootstrap'
//import ReactMarkdown from 'react-markdown'
import SubTextCollapse from '../SubTextCollapse'
import ExpandedItemHitRow from '../ExpandedItemHitRow'
import ReportLink from '../ReportLink'
import FlyBaseSymbol from '../FlyBaseSymbol'
//import Ribbon from 'react-ontology-ribbon'

import './index.css'

function expandArray(array, sep) {
  /* sep must be text */
  sep = sep || '; '
  if (array.length) {
    return array.join(sep)
  }
}

function reportLinkHash2Text(data, delim) {
  let list = []
  for (let k of Object.keys(data)) {
    if (k.match(/^[FB|SO|DO|MI|GO]/)) {
      /* match any valid data type key */
      // console.debug(k+": "+data[k]);
      list.push(data[k])
    }
  }
  return delim ? list.join(delim) : list.join(', ')
}

function reportLinkHash(data, delim, remove_) {
  if (!delim) delim = ', '
  let list = []
  let n = 0
  if (!data) return ''
  for (let k of Object.keys(data)) {
    // console.debug(k,data[k],delim);
    if (k.match(/^[FB|SO|DO|MI|GO|CHEBI]/)) {
      /* match any valid data type key */
      let sym = data[k]
      if (remove_) sym = sym.replace(/_/gi, ' ')
      if (n > 0)
        list.push(<span key={'ReportLinkSpan' + k + 'delim'}>{delim}</span>)
      list.push(
        <span key={'ReportLinkspan' + k}>
          <ReportLink key={k} id={k}>
            <FlyBaseSymbol symbol={sym} />
          </ReportLink>
        </span>
      )
      n++
    }
  }
  return list
}

function componentAlleles(data) {
  let list = []
  for( let a=0; a<data.length; a++ ) {
    let aObject = data[a]
    let sym = aObject.symbol
    sym = sym.replace(/_/gi, ' ')
    if (a > 0)
        list.push(<span key={'ReportLinkSpan' + a + 'delim'}>{", "}</span>)
    list.push(
        <span key={'AlleleLinkSpan' + a}>
          <ReportLink key={aObject.id} id={aObject.id}>
            <FlyBaseSymbol symbol={aObject.symbol} />
          </ReportLink>
        </span>
    )
  }
  return list
}

function xRefButton(itemID,xRef,dcLabels,num) {
  const xr_s = num === 1 ? '' : 's'
  let xr_dsbl = num > 0 ? '' : 'disabled'
  return <a
       className={'btn btn-xs btn-lite ' + xr_dsbl}
       href={'/hitlist/' + itemID + '/to/' + xRef}>
       {num} {dcLabels[xRef]}{xr_s}
     </a>
}

function domainListUnique(domainsArr) {
  domainsArr.sort(function (a, b) {
    return a.start - b.start
  })
  let hash = {}
  for (let i = 0; i < domainsArr.length; i++) {
    let domain = domainsArr[i]
    if (hash.hasOwnProperty(domain.abbrev)) hash[domain.abbrev]++
    else hash[domain.abbrev] = 1
  }
  // console.debug(hash);
  let domains = []
  let keys = Object.keys(hash)
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i]
    let num = hash[key] > 1 ? ' (' + hash[key] + ' repeats)' : ''
    if (i > 0)
      domains.push(<span key={'domainListSpan' + i + 'comma'}>, </span>)
    domains.push(
      <span key={'domainListSpan' + key} style={{ whiteSpace: 'nowrap' }}>
        {key + num}
      </span>
    )
  }
  return domains
}

const ItemPanel = observer(({ children, ...props }) => {
  return <Panel {...props}>{children}</Panel>
})

const FBab = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const st_s = item.num_stocks === 1 ? '' : 's'
    const rf_s = item.num_publications === 1 ? '' : 's'
    const lc_s = item.num_datasets === 1 ? '' : 's'
    const de_s = item.deleted_segments.length === 1 ? '' : 's'
    const du_s = item.duplicated_segments.length === 1 ? '' : 's'
    const de_d = item.deleted_segments.length ? {} : { display: 'none' }
    const du_d = item.duplicated_segments.length ? {} : { display: 'none' }
    let st_dsbl = item.num_stocks > 0 ? '' : 'disabled'
    let rf_dsbl = item.num_publications > 0 ? '' : 'disabled'
    let lc_dsbl = item.num_datasets > 0 ? '' : 'disabled'
    /*    let bp_loc  = ( item.cds_length && item.associated_polypeptide && Object.keys(item.associated_polypeptide).length )
            ? <span><b>Associated&nbsp;polypeptide:&emsp;</b>{reportLinkHash(item.associated_polypeptide)} ({item.cds_length} aa)</span>
            : ''; */
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        <Row>
          <Col sm={6} md={5} mdOffset={1}>
            <b>Feature type:&emsp;</b>
            {reportLinkHash(item.class, false, true)}
          </Col>
          <Col sm={6} style={{ display: 'none' }}>
            <b>Sequence location:&emsp;</b>
            [not yet implemented] {item.location}
          </Col>
        </Row>
        <Row>
          <Col xsHidden={true} smHidden={true} md={1} />
          <Col sm={6} md={5} style={de_d}>
            <b>
              {' '}
              Deleted&nbsp;segment
              {de_s}
              :&emsp;
            </b>
            {item.deleted_segments}
          </Col>
          <Col sm={6} style={du_d}>
            <b>
              Duplicated&nbsp;segment
              {du_s}
              :&emsp;
            </b>
            {item.duplicated_segments}
          </Col>
        </Row>
        <Row>
          <Col mdOffset={1}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + st_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBst'}>
                  {item.num_stocks} Stock
                  {st_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} Reference
                  {rf_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + lc_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBlc'}>
                  {item.num_datasets} Collection
                  {lc_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
)

FBab.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBal = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const in_s = Object.keys(item.associated_insertions).length === 1 ? '' : 's'
    const st_s = item.num_stocks === 1 ? '' : 's'
    const rf_s = item.num_publications === 1 ? '' : 's'
    let st_dsbl = item.num_stocks > 0 ? '' : 'disabled'
    let rf_dsbl = item.num_publications > 0 ? '' : 'disabled'
    let alClass =
      Object.keys(item.class).length === 0 ? (
        ''
      ) : (
        <Row>
          <Col sm={12} mdOffset={1} md={10}>
            <b>Allele class:&emsp;</b>
            {reportLinkHash(item.class)}
          </Col>
        </Row>
      )
    let lesion = item.known_lesion === '1' ? 'yes' : 'no'
    let mutagens = item.mutagens ? item.mutagens.join(', ') : ''
    // associated constructs or insertions row
    let assoc = [<Col key="assoc1" xsHidden smHidden md={1} />]
    if (
      Object.keys(item.associated_insertions).length > 0 &&
      Object.keys(item.carried_in_constructs).length > 0
    ) {
      assoc.push(
        <Col key="assoc2" sm={6} md={5}>
          <b>
            Associated&nbsp;insertion
            {in_s}
            :&emsp;
          </b>
          {reportLinkHash(item.associated_insertions)}
        </Col>
      )
      assoc.push(
        <Col key="assoc3" sm={6}>
          <div
            style={{
              maxHeight: '60px',
              overflowX: 'hidden',
              overflowY: 'auto',
              marginRight: -15,
            }}>
            <b>Carried in construct:&emsp;</b>
            {reportLinkHash(item.carried_in_constructs)}
          </div>
        </Col>
      )
    } else if (Object.keys(item.associated_insertions).length > 0) {
      assoc.push(
        <Col key="assoc4" md={10}>
          <b>
            Associated&nbsp;insertion
            {in_s}
            :&emsp;
          </b>
          {reportLinkHash(item.associated_insertions)}
        </Col>
      )
    } else if (Object.keys(item.carried_in_constructs).length > 0) {
      assoc.push(
        <Col key="assoc5" md={10}>
          <div
            style={{
              maxHeight: '60px',
              overflowX: 'hidden',
              overflowY: 'auto',
              marginRight: -15,
            }}>
            <b>Carried in construct:&emsp;</b>
            {reportLinkHash(item.carried_in_constructs)}
          </div>
        </Col>
      )
    } else {
      assoc.push(
        <Col key="assoc6" md={10}>
          <b>No associated insertions or constructs</b>
        </Col>
      )
    }
    assoc = <Row>{assoc}</Row>
    // phenotypic statements and disease models row
    const pc_s = item.num_phenotype_class === 1 ? '' : 's'
    const pa_s = item.num_phenotype_anatomy === 1 ? '' : 's'
    const dm_s = item.num_disease_models === 1 ? '' : 's'
    let stmnts = []
    if (item.num_phenotype_class > 0) {
      stmnts.push(
        <span key="stmnt1" style={{ whiteSpace: 'nowrap' }}>
          <b>{item.num_phenotype_class}</b> Phenotype (Class) statement
          {pc_s}
        </span>
      )
    }
    if (item.num_phenotype_anatomy > 0) {
      if (item.num_phenotype_class > 0)
        stmnts.push(<span key="stmnt2">,&emsp;</span>)
      stmnts.push(
        <span key="stmnt3" style={{ whiteSpace: 'nowrap' }}>
          <b>{item.num_phenotype_anatomy}</b> Phenotype (Anatomy) statement
          {pa_s}
        </span>
      )
    }
    if (item.num_disease_models > 0) {
      if (stmnts.length > 0) stmnts.push(<span>,&emsp;and </span>)
      stmnts.push(
        <span key="stmnt4" style={{ whiteSpace: 'nowrap' }}>
          <b>{item.num_disease_models}</b> Disease Model annotation
          {dm_s}
        </span>
      )
    }
    if (stmnts.length === 0)
      stmnts.push(
        <Row key="stmnt5">
          <Col mdOffset={1} md={10}>
            <b>No phenotype statements</b>
          </Col>
        </Row>
      )
    else {
      stmnts = [
        <Row key="stmnt6">
          <Col mdOffset={1} md={10}>
            {stmnts}
          </Col>
        </Row>,
      ]
    }
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        {alClass}
        <Row>
          <Col sm={6} mdOffset={1} md={5}>
            <b>Mutagen:&emsp;</b>
            {mutagens}
          </Col>
          <Col sm={6}>
            <b>Known lesion?&emsp;</b>
            {lesion}
          </Col>
        </Row>
        {assoc}
        {stmnts}
        <Row>
          <Col mdOffset={1}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + st_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBst'}>
                  {item.num_stocks} {dataClassLabels.FBst}
                  {st_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} {dataClassLabels.FBrf}
                  {rf_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
)
/*
      <Row>
        <Col sm={12} mdOffset={1} md={10}><b>Allele class:&emsp;</b>{reportLinkHash(item.class)}</Col>
      </Row>

      <Row>
        <Col sm={6}  mdOffset={1} md={5}><b>Associated&nbsp;insertion{in_s}:&emsp;</b>{reportLinkHash(item.associated_insertions)}</Col>
        <Col sm={6}><div style={{maxHeight:'60px',overflowX:'hidden',overflowY:'auto',marginRight:-15}}><b>Carried in construct:&emsp;</b>{reportLinkHash(item.carried_in_constructs)}</div></Col>
      </Row>

      <Row>
        <Col sm={6} mdOffset={1} md={5}><b>{item.num_phenotype_class} Phenotype (class) statements</b></Col>
        <Col sm={6}><b>{item.num_phenotype_anatomy} Phenotype (anatomy) statements</b></Col>
      </Row>
      <Row>
        <Col mdOffset={1} md={10}><b>{item.num_disease_models} Disease model annotations</b></Col>
      </Row>
*/

FBal.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBba = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const st_s = item.num_stocks === 1 ? '' : 's'
    let st_dsbl = item.num_stocks > 0 ? '' : 'disabled'
    const rf_s = item.num_publications === 1 ? '' : 's'
    let rf_dsbl = item.num_publications > 0 ? '' : 'disabled'
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        <Row>
          <Col sm={6} md={5} mdOffset={1}>
            <b>Short Genotype:&emsp;</b>
            <span dangerouslySetInnerHTML={{ __html: item.short_genotype }} />
          </Col>
          <Col sm={6}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + st_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBst'}>
                  {item.num_stocks} Stock
                  {st_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} Reference
                  {rf_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
)

FBba.propTypes = {
  item: PropTypes.object.isRequired,
}

/**
 * TODO Jim - Implement list view for FBch.
 *
 * Example FBch item attributes:
 *  {
 *    "num_publications" : 4,
 *    "name" : "α-terpinene",
 *    "score" : null,
 *    "definition" : "ChEBI: Alpha-terpinene is one of three isomeric monoterpenes differing in the positions of
 *    their two double bonds (beta- and gamma-terpinene being the others). In alpha-terpinene the double bonds are at
 *    the 1- and 3-positions of the p-menthane skeleton. It has a role as a volatile oil component and a plant
 *    metabolite. It is a monoterpene and a cyclohexadiene.",
 *    "data_type" : "FBch",
 *    "update_status" : null,
 *    "pubchem" : "7462",
 *    "chebi" : "CHEBI:10334",
 *    "id" : "FBch0000219"
 *  }
 *
 *  ChEBI Image URL:
 *  https://www.ebi.ac.uk/chebi/displayImage.do?defaultImage=true&imageIndex=0&chebiId=<CHEBI ID>
 *
 *  There is no "CHEBI:" prefix in <CHEBI ID>
 *
 *  URL also accepts a &dimensions=<integer> where the integer is the width and length
 *  e.g. &dimensions=300 returns a 300x300 px image.
 *  Default is 200x200.
 *
 *  @param {object} item - FBch object from API.
 *  @type {function({item: *, fields: *, dataClassLabels: *, children: *, [p: string]: *})}
 */
const FBch = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const rf_s = item.num_publications === 1 ? '' : 's'
    let rf_dsbl = item.num_publications > 0 ? '' : 'disabled'
    const cr_s = item.roles && item.roles.length === 1 ? '' : 's'
    // ChEBI images are nicer, but PubChem has more of them so they go first
    const chemimgurl =
      (item.pubchem) ?
      'https://pubchem.ncbi.nlm.nih.gov/image/imagefly.cgi?width=108&height=108&cid=' +
      item.pubchem
      :
      'https://www.ebi.ac.uk/chebi/displayImage.do?defaultImage=true&dimensions=100&imageIndex=0&chebiId=' +
      item.chebi
    const linklist = function (lvl) {
      const lst = []
      for (let k in item[lvl]) {
        if (item[lvl][k]) {
          const gp = item[lvl][k]
          if (gp) {
            if (k > 0) lst.push(<span key={gp.id + '_delim'}>;&emsp;</span>)
            lst.push(
              <ReportLink key={'link_' + gp.id} id={gp.id}>
                {gp.name}
              </ReportLink>
            )
          }
        }
      }
      return <span>{lst}</span>
    }
    const rolesRow = function(item) {
      if (item.roles.length > 0) {
        return (
            <Row>
              <Col sm={12}>
                <b>Role{cr_s}:&emsp;</b>
                {linklist('roles')}
              </Col>
            </Row>
        )
      }
    }
    const extlnks = function () {
      let lis = []
      if(item.chebi)
        lis.push(
              <li>
                <a
                  className={'btn btn-xs btn-lite'}
                  href={
                    'https://www.ebi.ac.uk/chebi/searchId.do?chebiId=' +
                    item.chebi
                  }>
                  CHEBI
                </a>
              </li>
        )
      if(item.pubchem)
        lis.push(
              <li>
                <a
                  className={'btn btn-xs btn-lite'}
                  href={
                    'https://pubchem.ncbi.nlm.nih.gov/compound/' + item.pubchem
                  }>
                  PubChem
                </a>
              </li>
        )
      return <ul className="list-inline" style={{ margin: '0 10px' }}>{lis}</ul>
    }
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          hit={item.name}
        />
        <Row>
          <Col sm={9} mdOffset={1}>
            <Row style={{ paddingTop: 5 }}>
              <Col sm={12}>
                <SubTextCollapse label="Definition" text={item?.definition} />
              </Col>
            </Row>
            {rolesRow(item)}
            <Row>
              <Col>
                {extlnks()}
              </Col>
            </Row>
            <Row>
              <Col>
                <ul className="list-inline" style={{ margin: '0 10px' }}>
                  <li>
                    <a
                      className={'btn btn-xs btn-lite ' + rf_dsbl}
                      href={'/hitlist/' + item.id + '/to/FBrf'}>
                      {item?.num_publications ?? 0} Reference
                      {rf_s}
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
          <Col sm={3} md={2}>{' '}
            <div style={{ textAlign: 'center', marginTop: -10 }}>
              <img alt="unavailable" src={chemimgurl} style={{ borderRadius: 10 }} />
            </div>{' '}
          </Col>
        </Row>
      </div>
    )
  }
)

FBch.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBcl = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const gn_s = Object.keys(item.computed_genes).length === 1 ? '' : 's'
    const st_s = item.stages.length === 1 ? '' : 's'
    const ts_s = Object.keys(item.tissues).length === 1 ? '' : 's'
    const lb_s = Object.keys(item.libraries).length === 1 ? 'y' : 'ies'
    const stages = item.stages.join('; ')
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          hit={item.name}
        />
        <Row style={{ whiteSpace: 'nowrap' }}>
          <Col lg={3} md={5} mdOffset={1} sm={6}>
            <b>Feature type:&emsp;</b>
            {item.type}
          </Col>
          <Col lg={3} sm={6} style={{ whiteSpace: 'normal' }}>
            <b>
              Computed gene
              {gn_s}
              :&emsp;
            </b>
            {reportLinkHash(item.computed_genes)}
          </Col>
          <Col
            xsHidden={true}
            sm={6}
            md={5}
            mdOffset={1}
            lgHidden={true}
            style={{ whiteSpace: 'normal' }}>
            <b>
              Stage
              {st_s}
              :&emsp;
            </b>
            {stages}
          </Col>
          <Col sm={6} lg={5}>
            <b>
              Librar
              {lb_s}
              :&emsp;
            </b>
            {reportLinkHash(item.libraries)}
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={6} mdOffset={1}>
            <b>
              Tissue Source
              {ts_s}
              :&emsp;
            </b>
            {reportLinkHash(item.tissues)}
          </Col>
          <Col smHidden={true} mdHidden={true} lg={5}>
            <b>
              Stage
              {st_s}
              :&emsp;
            </b>
            {stages}
          </Col>
        </Row>
      </div>
    )
  }
)

FBcl.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBco = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const hasExpression = item?.expression === '1'
    const hasImages = item?.images === '1'
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        <Row>
          <Col sm={12} md={11} mdOffset={1} lg={6}>
            <b>
              Component&nbsp;alleles:&emsp;
            </b>
            {componentAlleles(item.component_alleles)}
          </Col>
          <CheckCol xs={6} mdOffset={1} md={5} lg={3} lgOffset={0}>
            <span style={{ fontWeight: 'bold', paddingRight: '0.75rem' }}>
              Expression Data:
            </span>
            <CheckCircle isChecked={hasExpression} />
          </CheckCol>
          <CheckCol xs={6} lg={2}>
            <span style={{ fontWeight: 'bold', paddingRight: '0.75rem' }}>
              Image(s):
            </span>
            <CheckCircle isChecked={hasImages} />
          </CheckCol>
        </Row>
        <Row>
          <Col xsHidden={true} sm={4} md={3} mdOffset={1}>
            {xRefButton(item.id,"FBal",dataClassLabels,2)}
          </Col>
          <Col xsHidden={true} sm={3}>
            {xRefButton(item.id,"FBst",dataClassLabels,item.num_stocks)}
          </Col>
          <Col xsHidden={true} sm={5}>
            {xRefButton(item.id,"FBrf",dataClassLabels,item.num_pubs)}
          </Col>
        </Row>
      </div>
    )
  }
)

FBco.propTypes = {
  item: PropTypes.object.isRequired,
}

const CVterm = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          hit={item.name.replace(/_/g, ' ')}
          text={'(' + item.id.replace(/_/g, ' ') + ')'}
        />
        <Row>
          <Col xs={12} mdOffset={1} md={11}>
            {item.definition}
          </Col>
        </Row>
      </div>
    )
  }
)
//      <SubTextCollapse label="Definition" text={item.definition}></SubTextCollapse>

CVterm.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBgg = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const pg_s = item.parents && item.parents.length === 1 ? '' : 's'
    const cg_s = item.components && item.components.length === 1 ? '' : 's'
    const linklist = function (lvl) {
      const lst = []
      for (let k in item[lvl]) {
        if (item[lvl][k]) {
          const gp = item[lvl][k]
          if (gp) {
            if (k > 0) lst.push(<span key={gp.id + '_delim'}>, </span>)
            lst.push(
              <ReportLink key={'link_' + gp.id} id={gp.id}>
                <span>{gp.name}</span>
              </ReportLink>
            )
          }
        }
      }
      return <span>{lst}</span>
    }
    // <Col sm={4} mdOffset={1} md={3}><b>Number of members:&emsp;</b>{item.num_members}</Col>
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          hit={item.name}
        />
        <Row>
          <Col sm={5} mdOffset={1} md={4}>
            <b>{item.num_members} genes in this group</b>
          </Col>
          <Col sm={7}>
            <b>
              Parent group
              {pg_s}
              :&emsp;
            </b>
            {linklist('parents')}
          </Col>
        </Row>
        <Row>
          <Col sm={12} mdOffset={1} md={10}>
            <b>
              Component group
              {cg_s}
              :&emsp;
            </b>
            {linklist('components')}
          </Col>
        </Row>
        <Row style={{ paddingTop: 5 }}>
          <Col sm={12} md={10} mdOffset={1}>
            <SubTextCollapse label="Description" text={item.description} />
          </Col>
        </Row>
      </div>
    )
  }
)

FBgg.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBgn = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const al_s = item.num_alleles === 1 ? '' : 's'
    const st_s = item.num_stocks === 1 ? '' : 's'
    const tr_s = item.num_transcripts === 1 ? '' : 's'
    const pp_s = item.num_polypeptides === 1 ? '' : 's'
    const rf_s = item.num_publications === 1 ? '' : 's'
    const al_dsbl = item.num_alleles ? '' : 'disabled'
    const st_dsbl = item.num_stocks ? '' : 'disabled'
    const tr_dsbl = item.num_transcripts ? '' : 'disabled'
    const pp_dsbl = item.num_polypeptides ? '' : 'disabled'
    const rf_dsbl = item.num_publications ? '' : 'disabled'
    const ftype = item.feature_type.replace(/_/g, ' ')
    //  const synonyms = item.synonyms.join(', ');
    let tlist = [item.id]
    let name = item.name ? item.name : ''
    if (item.annotation_id) tlist.unshift(item.annotation_id)
    /*    const ribbonData = [
      {
        id: 'GO:0008150',
        name: 'BP',
        descendant_terms: new Array(item.num_go.biological_process),
      },
      {
        id: 'GO:0005575',
        name: 'CC',
        descendant_terms: new Array(item.num_go.cellular_component),
      },
      {
        id: 'GO:0003674',
        name: 'MF',
        descendant_terms: new Array(item.num_go.molecular_function),
      },
    ]*/
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          text={name + ' (' + tlist.join(',&nbsp;') + ')'}
        />
        <Row style={{ display: 'none' }}>
          <Col
            xsHidden={true}
            smHidden={true}
            sm={3}
            style={{ textAlign: 'right' }}>
            <b>AKA:&emsp;</b>
          </Col>
          <Col xsHidden={true} smHidden={true} sm={9} md={7}>
            &lt;list of synonyms&gt;
          </Col>
          <Col mdHidden={true} lgHidden={true} xs={12}>
            <b>AKA:&emsp;</b>
            &lt;list of synonyms&gt;
          </Col>
        </Row>
        <Row>
          <Col
            xsHidden={true}
            smHidden={true}
            md={3}
            style={{ textAlign: 'right' }}>
            <b>Feature type:</b>
          </Col>
          <Col xsHidden={true} smHidden={true} md={3}>
            {ftype}
          </Col>
          <Col
            xsHidden={true}
            smHidden={true}
            md={3}
            style={{ textAlign: 'right' }}>
            <b>Gene model status:</b>
          </Col>
          <Col xsHidden={true} smHidden={true} md={3}>
            {item.model_status}
          </Col>

          <div className="visible-sm col-sm-6" style={{ whiteSpace: 'nowrap' }}>
            <b>Feature type:&emsp;</b>
            {ftype}
          </div>
          <div className="visible-sm col-sm-6" style={{ whiteSpace: 'nowrap' }}>
            <b>Gene model status:&emsp;</b>
            {item.model_status}
          </div>

          <div className="visible-xs col-xs-12">
            <b>Feature type:&emsp;</b>
            <span style={{ whiteSpace: 'nowrap' }}>{ftype}</span>
          </div>
          <div className="visible-xs col-xs-12">
            <b>Gene model status:&emsp;</b>
            <span style={{ whiteSpace: 'nowrap' }}>{item.model_status}</span>
          </div>
        </Row>
        <Row>
          <Col
            xsHidden={true}
            smHidden={true}
            md={3}
            style={{ textAlign: 'right' }}>
            <b>Sequence Location:</b>
          </Col>
          <Col xsHidden={true} smHidden={true} md={3}>
            <span style={{ whiteSpace: 'nowrap' }}>{item.location}</span>
          </Col>
          <Col
            xsHidden={true}
            smHidden={true}
            md={3}
            style={{ textAlign: 'right' }}>
            <b>Cytogenetic Map:</b>
          </Col>
          <Col xsHidden={true} smHidden={true} md={3}>
            {item.cytology}
          </Col>

          <Col mdHidden={true} lgHidden={true} className="col-xs-12">
            <b>Sequence Location:&emsp;</b>
            <span style={{ whiteSpace: 'nowrap' }}>{item.location}</span>
          </Col>
          <Col mdHidden={true} lgHidden={true} className="col-xs-12">
            <b>Cytogenetic Map:&emsp;</b>
            <span style={{ whiteSpace: 'nowrap' }}>{item.cytology}</span>
          </Col>
        </Row>
        <Row style={{ whiteSpace: 'nowrap' }}>
          <Col xsHidden={true} smHidden={true} md={2} mdOffset={1}>
            <a
              className={'btn btn-xs btn-lite ' + al_dsbl}
              href={'/hitlist/' + item.id + '/to/FBal'}>
              {item.num_alleles} Allele
              {al_s}
            </a>
          </Col>
          <Col xsHidden={true} smHidden={true} md={2}>
            <a
              className={'btn btn-xs btn-lite ' + st_dsbl}
              href={'/hitlist/' + item.id + '/to/FBst'}>
              {item.num_stocks} Stock
              {st_s}
            </a>
          </Col>
          <Col xsHidden={true} smHidden={true} md={2}>
            <a
              className={'btn btn-xs btn-lite ' + tr_dsbl}
              href={'/hitlist/' + item.id + '/to/FBtr'}>
              {item.num_transcripts} Transcript
              {tr_s}
            </a>
          </Col>
          <Col xsHidden={true} smHidden={true} md={2}>
            <a
              className={'btn btn-xs btn-lite ' + pp_dsbl}
              href={'/hitlist/' + item.id + '/to/FBpp'}>
              {item.num_polypeptides} Polypeptide
              {pp_s}
            </a>
          </Col>
          <Col xsHidden={true} smHidden={true} md={2}>
            <a
              className={'btn btn-xs btn-lite ' + rf_dsbl}
              href={'/hitlist/' + item.id + '/to/FBrf'}>
              {item.num_publications} Reference
              {rf_s}
            </a>
          </Col>
        </Row>
        <Row>
          <Col mdHidden={true} lgHidden={true}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + al_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBal'}>
                  {item.num_alleles} Allele
                  {al_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + st_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBst'}>
                  {item.num_stocks} Stock
                  {st_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + tr_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBtr'}>
                  {item.num_transcripts} Transcript
                  {tr_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + pp_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBpp'}>
                  {item.num_polypeptides} Polypeptide
                  {pp_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} Reference
                  {rf_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row style={{ paddingTop: 5 }}>
          <Col sm={12} md={10} mdOffset={1}>
            <SubTextCollapse label="Gene Snapshot" text={item.snapshot} />
          </Col>
        </Row>
        {/*<Row style={{ whiteSpace: 'nowrap', display: 'none' }}>
          <Col sm={2} mdOffset={1}>
            <b>GO annotations:</b>
          </Col>
          <Col sm={9}>
            <Ribbon data={ribbonData} />
          </Col>
        </Row>*/}
      </div>
    )
  }
)
/*
            lst.push(<li><a className={"btn btn-xs btn-lite "+dsbl} href={"/hitlist/"+item.id+"/to/"+k}>{count} {dataClassLabels[k]}{s}</a></li>);
        }
        return <Row><Col mdOffset={1}><ul className="list-inline" style={{margin:'0 10px'}}>{lst}</ul></Col></Row>;
*/
FBgn.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBhh = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    let hgnc = []
    for (let i = 0; i < item.hgnc.length; i++) {
      let hgncObj = item.hgnc[i]
      let hgncURL = hgncObj.url
      let hgncDsc = hgncObj.description
      if (i > 0) hgnc.push(<span key={'hgnc_spacer' + i}>,&emsp;</span>)
      hgnc.push(
        <a href={hgncURL} key={'hgnc' + i}>
          {hgncDsc}
        </a>
      )
    }
    const omim = item.omim ? (
      <a href={'https://omim.org/entry/' + item.omim.accession}>
        {item.omim.description}
      </a>
    ) : (
      ''
    )
    const hg_s = item.hgnc.length === 1 ? '' : 's'
    const gn_s = Object.keys(item.genes).length === 1 ? '' : 's'
    const sb_s = item.num_subtypes === 1 ? '' : 's'
    let sb_dsbl = item.num_subtypes > 0 ? '' : 'disabled'
    const rf_s = item.num_publications === 1 ? '' : 's'
    let rf_dsbl = item.num_publications > 0 ? '' : 'disabled'
    const rl_s = item.num_related === 1 ? '' : 's'
    let rl_dsbl = item.num_related > 0 ? '' : 'disabled'
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          hit={item.name}
        />
        <Row>
          <Col sm={6} mdOffset={1} md={5}>
            <b>Associated DO term:&emsp;</b>
            {reportLinkHash(item.do, false, true)}
          </Col>
          <Col sm={6}>
            <b>Associated OMIM term:&emsp;</b>
            {omim}
          </Col>
        </Row>
        <Row>
          <Col sm={6} mdOffset={1} md={5}>
            <b>
              Human Gene
              {hg_s} implicated (HGNC):&emsp;
            </b>
            {hgnc}
          </Col>
          <Col sm={6}>
            <b>
              <i>D. melanogaster</i> Ortholog
              {gn_s}
              :&emsp;
            </b>
            {reportLinkHash(item.genes)}
          </Col>
        </Row>
        <Row>
          <Col mdOffset={1}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + sb_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBhh?qualifier=subtype'}>
                  {item.num_subtypes} Subtype Group Member
                  {sb_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rl_dsbl}
                  href={
                    '/hitlist/' + item.id + '/to/FBhh?qualifier=associated_with'
                  }>
                  {item.num_related} Related Disease Report
                  {rl_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} Reference
                  {rf_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row style={{ paddingTop: 5 }}>
          <Col sm={12} md={11} mdOffset={1}>
            <SubTextCollapse
              label="Overview"
              text={item.overview}
              className="text-warning"
            />
          </Col>
        </Row>
      </div>
    )
  }
)

FBhh.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBig = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const symbs = Object.keys(item.genes)
    let hitTxt =
      symbs.length === 1
        ? item.genes[symbs[0]] + ' &hArr; ' + item.genes[symbs[0]]
        : reportLinkHash2Text(item.genes, ' &hArr; ')
    const tp_s = item.types.length === 1 ? '' : 's'
    const rf_s = item.num_publications === 1 ? '' : 's'
    let rf_dsbl = item.num_publications > 0 ? '' : 'disabled'
    const in_s = item.num_interactions === 1 ? '' : 's'
    const su_s = item.num_interactions === 1 ? 's' : '' // for support(s)
    let in_stmt =
      Object.keys(item.genes).length === 1
        ? 'self-interaction of'
        : 'an interaction between'
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          hit={hitTxt}
        />
        <Row>
          <Col sm={6} mdOffset={1} md={5}>
            <b>
              Interaction type
              {tp_s}
              :&emsp;
            </b>
            {item.types}
          </Col>
          <Col sm={6}>
            <b>Description:&emsp;</b>
            {expandArray(item.descriptions)}
          </Col>
        </Row>
        <Row>
          <Col sm={9} mdOffset={1} md={8}>
            <b>
              {item.num_interactions} experiment
              {in_s} support
              {su_s} {in_stmt} {reportLinkHash(item.genes, ' and ')}
            </b>
          </Col>
          <Col sm={6}>
            <b />
          </Col>
        </Row>
        <Row>
          <Col mdOffset={1}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} Reference
                  {rf_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
)

FBig.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBim = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const thmbURL = '/images/FBim/' + item.thumbnail
    // const descrpt = item.description.substring(0, item.description.length-1);
    const descrpt = item.caption.substring(0, item.caption.indexOf('.'))
    const fbbtURL = '/hitlist/' + item.id + '/to/FBbt'
    const fbbtnum = item.num_anatomy
    const fbbt_s = fbbtnum === 1 ? '' : 's'
    const fbdvURL = '/hitlist/' + item.id + '/to/FBdv'
    const fbdvnum = item.num_stage
    const fbdv_s = fbdvnum === 1 ? '' : 's'
    const gobpURL = '/hitlist/' + item.id + '/to/GO'
    const gobpnum = item.num_biological_process
    const gobp_s = gobpnum === 1 ? '' : 's'
    const buttonList = function () {
      var lis = []
      if (fbbtnum > 0)
        lis.push(
          <li>
            <a className={'btn btn-xs btn-lite'} href={fbbtURL}>
              {fbbtnum} Anatomy Term
              {fbbt_s}
            </a>
          </li>
        )
      if (fbdvnum > 0)
        lis.push(
          <li>
            <a className={'btn btn-xs btn-lite'} href={fbdvURL}>
              {fbdvnum} Stage Term
              {fbdv_s}
            </a>
          </li>
        )
      if (gobpnum > 0)
        lis.push(
          <li>
            <a className={'btn btn-xs btn-lite'} href={gobpURL}>
              {gobpnum} Process Term
              {gobp_s}
            </a>
          </li>
        )
      return <ul className="list-inline">{lis}</ul>
    }
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          hit={descrpt}
        />
        <Row>
          <Col sm={3} md={2} style={{ paddingTop: 15, textAlign: 'right' }}>
            <ReportLink key={item.id} id={item.id}>
              <img
                src={thmbURL}
                alt={item.id}
                className="img-rounded img-thumbnail"
              />
            </ReportLink>
          </Col>
          <Col sm={10}>
            <Row style={{ paddingTop: 8 }}>
              <Col sm={12} lg={6}>
                <div style={{ lineHeight: 1.5, padding: '4px 0px' }}>
                  <b>
                    <span dangerouslySetInnerHTML={{ __html: item.name }} />
                  </b>
                </div>
              </Col>
              <Col sm={12} className={'hidden-lg'}>
                {buttonList()}
              </Col>
              <Col lg={6} className={'visible-lg text-right'}>
                {buttonList()}
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <span dangerouslySetInnerHTML={{ __html: item.caption }} />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
)
//            <Col sm={12} md={10}    className={"hidden-lg"}><a className={"btn btn-xs btn-lite"} href={fbbtURL}>{fbbtnum} Anatomy Term{fbbt_s}</a><a className={"btn btn-xs btn-lite"} href={fbdvURL}>{fbdvnum} Stage Term{fbdv_s}</a></Col>
//            <Col lg={4} className={"visible-lg text-right"}><a className={"btn btn-xs btn-lite"} href={fbbtURL}>{fbbtnum} Anatomy Term{fbbt_s}</a><a className={"btn btn-xs btn-lite"} href={fbdvURL}>{fbdvnum} Stage Term{fbdv_s}</a></Col>
//           <SubTextCollapse label="Caption" text={item.caption}></SubTextCollapse>

FBim.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBlc = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const lcType =
      item.type && Object.keys(item.type).length === 0 ? (
        ''
      ) : (
        <Col sm={6} mdOffset={1} md={5}>
          <b>Type:&emsp;</b>
          {reportLinkHash(item.type, false, true)}
        </Col>
      )
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        <Row>
          <Col sm={6} md={5} mdOffset={1}>
            <b>Class:&emsp;</b>
            {item.class}
          </Col>
          {lcType}
        </Row>
        <Row>
          <Col sm={12} md={11} mdOffset={1}>
            <b>Title:&emsp;</b>
            <span dangerouslySetInnerHTML={{ __html: item.title }} />
          </Col>
        </Row>
      </div>
    )
  }
)

FBlc.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBpp = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const rf_s = item.num_publications === 1 ? '' : 's'
    let rf_dsbl = item.num_publications > 0 ? '' : 'disabled'
    const tr_s = item.num_encoded_by === 1 ? '' : 's'
    const enc_by = item.num_encoded_by
      ? 'This polypeptide also encoded by ' +
        item.num_encoded_by +
        ' other transcript' +
        tr_s
      : ''
    const domains = function () {
      if (Object.keys(item.domains).length) {
        return (
          <Row title={'domains listed once, with frequency in parentheses'}>
            <Col md={10} mdOffset={1}>
              <b>Domains:&emsp;</b>
              {domainListUnique(item.domains)}
            </Col>
          </Row>
        )
      }
    }
    let tlist = [item.annotation_id, item.id]
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          text={'(' + tlist.join(',&nbsp;') + ')'}
        />
        <Row>
          <Col sm={6} md={5} mdOffset={1}>
            <b>Length (aa):&emsp;</b>
            {item.length}
          </Col>
          <Col sm={6}>
            <b>Predicted MW (kDa):&emsp;</b>
            {item.predicted_mw}
          </Col>
        </Row>
        <Row>
          <Col sm={6} md={5} mdOffset={1}>
            <b>Associated&nbsp;gene:&emsp;</b>
            {reportLinkHash(item.associated_gene)}
          </Col>
          <Col sm={6}>
            <b>Associated transcript:&emsp;</b>
            {reportLinkHash(item.associated_transcript)}
          </Col>
        </Row>
        <Row>
          <Col sm={6} md={5} mdOffset={1}>
            <b>Unique polypeptides for this gene:&emsp;</b>
            {item.num_unique_polypeptides}
          </Col>
          <Col sm={6}>
            <b>{enc_by}</b>
          </Col>
        </Row>
        {domains()}
        <Row>
          <Col mdOffset={1}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} Reference
                  {rf_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
)

FBpp.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBrf = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    let pmid,
      pm_dsbl = 'disabled',
      pmcid,
      pmc_dsbl = 'disabled',
      jnlurl,
      jnl_dsbl = 'disabled',
      jnl_msvr = ''
    let hitText = item.year
      ? item.authors + ' (' + item.year + ')'
      : item.authors
    const list = function () {
      const lst = []
      for (const k in item.data_class_counts) {
        if (item.data_class_counts[k]) {
          const count = item.data_class_counts[k]
          const s = count === 1 ? '' : 's'
          let dsbl = count === 0 ? 'disabled' : ''
          lst.push(
            <li key={k + count}>
              <a
                className={'btn btn-xs btn-lite ' + dsbl}
                href={'/hitlist/' + item.id + '/to/' + k}>
                {count} {dataClassLabels[k]}
                {s}
              </a>
            </li>
          )
        }
      }
      return (
        <Row>
          <Col>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              {lst}
            </ul>
          </Col>
        </Row>
      )
    }
    for (let i = 0; i < item.dbxrefs.length; i++) {
      var dbxref = item.dbxrefs[i]
      if (dbxref.db.match(/pubmed/i)) {
        pm_dsbl = ''
        pmid =
          'http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?cmd=Retrieve&db=pubmed&dopt=AbstractPlus&tool=FlyBase&list_uids=' +
          dbxref.accession
      }
      if (dbxref.db.match(/pmcid/i)) {
        pmc_dsbl = ''
        pmcid = dbxref.accession
      }
      if (dbxref.db.match(/DOI/i)) {
        jnl_dsbl = ''
        jnlurl = 'http://dx.doi.org/' + dbxref.accession
      }
      if (dbxref.db.match(/url/i)) {
        jnl_dsbl = ''
        jnlurl = dbxref.url
      }
    }
    const ga_Col = function () {
      let ga_link = ''
      if (item.graphical_abstract)
        ga_link = (
          <img
            alt="Graphical Abstract"
            style={{ maxWidth: '100%', maxHeight: 120 }}
            src={'/images/graphical_abstracts/' + item.graphical_abstract}
          />
        )
      return (
        <Col md={3} lg={2}>
          {' '}
          <div style={{ textAlign: 'center' }}>
            <a href={'/reports/' + item.id}>{ga_link}</a>
          </div>{' '}
        </Col>
      )
    }
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          hit={hitText}
        />
        <Row>
          <Col md={8} mdOffset={1}>
            <Row>
              <Col md={12}>
                <b>Title:&emsp;</b>
                <span dangerouslySetInnerHTML={{ __html: item.title }} />
              </Col>
            </Row>
            <Row>
              <Col sm={7} md={6}>
                <b>Citation:&emsp;</b>
                <span>{item.miniref}</span>
              </Col>
              <Col sm={5}>
                <b>Publication type:&emsp;</b>
                {item.type}
              </Col>
            </Row>
            <Row style={{ whiteSpace: 'nowrap' }}>
              <Col xsHidden={true} sm={3}>
                <a className={'btn btn-xs btn-lite ' + pm_dsbl} href={pmid}>
                  PubMed
                </a>
              </Col>
              <Col xsHidden={true} sm={3}>
                <a
                  className={'btn btn-xs btn-lite ' + pmc_dsbl}
                  href={'http://www.ncbi.nlm.nih.gov/pmc/articles/' + pmcid}>
                  PMC
                </a>
              </Col>
              <Col xsHidden={true} sm={3}>
                <a
                  className={'btn btn-xs btn-lite ' + pmc_dsbl}
                  href={'http://europepmc.org/articles/' + pmcid}>
                  EuropePMC
                </a>
              </Col>
              <Col xsHidden={true} sm={3}>
                <a
                  className={'btn btn-xs btn-lite ' + jnl_dsbl}
                  href={jnlurl}
                  title={jnl_msvr}>
                  Journal website
                </a>
              </Col>
            </Row>
            <Row style={{ paddingTop: 5 }}>
              <Col sm={12}>
                <SubTextCollapse
                  label="Abstract"
                  text={item.abstract}
                  className="text-warning"
                />
              </Col>
            </Row>
            <Row>
              <Col className={'visible-xs'}>
                <ul className="list-inline" style={{ margin: '0 10px' }}>
                  <li>
                    <a className={'btn btn-xs btn-lite ' + pm_dsbl} href={pmid}>
                      PubMed
                    </a>
                  </li>
                  <li>
                    <a
                      className={'btn btn-xs btn-lite ' + pmc_dsbl}
                      href={
                        'http://www.ncbi.nlm.nih.gov/pmc/articles/' + pmcid
                      }>
                      PMC
                    </a>
                  </li>
                  <li>
                    <a
                      className={'btn btn-xs btn-lite ' + pmc_dsbl}
                      href={'http://europepmc.org/articles/' + pmcid}>
                      EuropePMC
                    </a>
                  </li>
                  <li>
                    <a
                      className={'btn btn-xs btn-lite ' + jnl_dsbl}
                      href={jnlurl}
                      title={jnl_msvr}>
                      Journal website
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
            {list()}
          </Col>
          {ga_Col()}
        </Row>
      </div>
    )
  }
)

FBrf.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBsf = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const ag_s = Object.keys(item.associated_genes).length === 1 ? '' : 's'
    const ds_s = Object.keys(item.associated_datasets).length === 1 ? '' : 's'
    const typeTreated = item.type.replace(/_/gi, ' ')
    //  const DSbox = <div>{reportLinkHash(item.associated_datasets)}</div>;
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        <Row>
          <Col sm={6} md={5} mdOffset={1}>
            <b>Feature type:&emsp;</b>
            {typeTreated}
          </Col>
          <Col sm={6}>
            <b>Sequence location:&emsp;</b>
            <span style={{ whiteSpace: 'nowrap' }}>{item.location}</span>
          </Col>
        </Row>
        <Row>
          <Col sm={6} md={5} mdOffset={1}>
            <b>
              Associated&nbsp;Gene
              {ag_s}
              :&emsp;
            </b>
            {reportLinkHash(item.associated_genes)}
          </Col>
          <Col sm={6}>
            <div
              style={{
                maxHeight: '60px',
                overflowX: 'hidden',
                overflowY: 'auto',
                marginRight: -15,
              }}>
              <b>
                Dataset
                {ds_s}
                /Collection
                {ds_s}
                :&emsp;
              </b>
              {reportLinkHash(item.associated_datasets)}
            </div>
          </Col>
        </Row>
      </div>
    )
  }
)

FBsf.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBsn = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const st_s = item.num_stocks === 1 ? '' : 's'
    const rf_s = item.num_publications === 1 ? '' : 's'
    const dc_s = Object.keys(item.collections).length === 1 ? '' : 's'
    const st_dsbl = item.num_stocks ? '' : 'disabled'
    const rf_dsbl = item.num_publications ? '' : 'disabled'
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          text={
            '(' +
            item.symbol +
            '&nbsp;' +
            item.species_abbrev +
            ', ' +
            item.id +
            ')'
          }
        />
        <Row>
          <Col mdOffset={1} md={11}>
            <b>
              Collection
              {dc_s}
              :&emsp;
            </b>
            {reportLinkHash(item.collections, false, true)}
          </Col>
        </Row>
        <Row>
          <Col mdOffset={1}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + st_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBst'}>
                  {item.num_stocks} Stock
                  {st_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} Reference
                  {rf_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
)

FBsn.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBst = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    let stocknum = item.stock_num ? item.stock_num : item.id
    let collection = item.collection
    let clcn = collection
    let sc_url = item.stock_num
    let sc_txt = ''
    if (collection.match(/bloomington/i)) {
      clcn = 'BDSC'
      sc_txt = 'Stock Center ' + item.stock_num
      sc_url = 'https://bdsc.indiana.edu/stocks/' + item.stock_num
    } else if (collection.match(/Carpenter/i)) {
      clcn = 'Carpenter'
    } else if (collection.match(/Exelixis/i)) {
      clcn = 'Exelixis'
    } else if (collection.match(/FlyORF/i)) {
      clcn = 'FlyORF'
    } else if (collection.match(/Garcia/i)) {
      clcn = 'Garcia-Bellido'
    } else if (collection.match(/GenetiVis/i)) {
      clcn = 'GenetiVision'
    } else if (collection.match(/Korea/i)) {
      clcn = 'KDRC'
    } else if (collection.match(/Kyoto/i)) {
      clcn = 'Kyoto'
      sc_txt = 'Stock Center ' + item.stock_num
      sc_url =
        'https://kyotofly.kit.jp/cgi-bin/stocks/search_res_det.cgi?DG_NUM=' +
        item.stock_num
    } else if (collection.match(/Nusslein/i)) {
      clcn = 'Nusslein-Volhard'
    } else if (collection.match(/Institute/i)) {
      clcn = 'NIG-Fly'
    } else if (collection.match(/National/i)) {
      clcn = 'NDSSC'
    } else if (collection.match(/Vienna/i)) {
      clcn = 'VDRC'
      sc_txt = 'Stock Center ' + item.stock_num
      sc_url =
        'http://stockcenter.vdrc.at/control/product/~product_id=' +
        item.stock_num
    }
    let complist = []
    for (let i = 0; i < item.components.length; i++) {
      let compObj = item.components[i]
      let k = Object.keys(compObj)[0]
      if (k.match(/^FB/))
        complist.push(
          <ReportLink key={k} id={k}>
            <FlyBaseSymbol symbol={compObj[k]} />
          </ReportLink>
        )
      if (k.match(/^string/))
        complist.push(
          <span key={k + Math.random()} id={k + Math.random()}>
            <FlyBaseSymbol symbol={compObj[k]} />
          </span>
        )
    }
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          hit={clcn + ':' + stocknum}
          linkoutTxt={sc_txt}
          linkoutURL={sc_url}
        />
        <Row>
          <Col sm={6} mdOffset={1} md={5} style={{ wordBreak: 'keep-all' }}>
            <b>Genotype:&emsp;</b>
            <span>{complist}</span>
          </Col>
          <Col sm={6}>
            <b>Collection:&emsp;</b>
            {item.collection}
          </Col>
        </Row>
      </div>
    )
  }
)

FBst.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBtc = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const sn_s = item.source_strains.length === 1 ? '' : 's'
    const ts_s = Object.keys(item.tissue_sources).length === 1 ? '' : 's'
    const ds_s = Object.keys(item.developmental_stages).length === 1 ? '' : 's'
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        <Row>
          <Col sm={6} md={5} mdOffset={1} lg={4}>
            <b>
              Source strain
              {sn_s}
              :&emsp;
            </b>
            <span dangerouslySetInnerHTML={{ __html: item.source_strains }} />
          </Col>
          <Col sm={6}>
            <b>
              Tissue&nbsp;source
              {ts_s}
              :&emsp;
            </b>
            <span style={{ whiteSpace: 'nowrap' }}>
              {reportLinkHash(item.tissue_sources)}
            </span>
          </Col>
        </Row>
        <Row>
          <Col sm={6} md={5} mdOffset={1} lg={4}>
            <b>DGRC&nbsp;Stock:&emsp;</b>
            {item.dgrc_stock}
          </Col>
          <Col sm={6}>
            <b>
              Dev.&nbsp;Stage
              {ds_s}
              :&emsp;
            </b>
            <span style={{ whiteSpace: 'nowrap' }}>
              {reportLinkHash(item.developmental_stages)}
            </span>
          </Col>
        </Row>
      </div>
    )
  }
)

FBtc.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBte = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const rf_s = item.num_publications === 1 ? '' : 's'
    let rf_dsbl = item.num_publications > 0 ? '' : 'disabled'
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        <Row>
          <Col sm={6} md={5} mdOffset={1}>
            <b>Size:&emsp;</b>
            {expandArray(item.size)}
          </Col>
          <Col sm={6}>
            <b>GenBank&nbsp;accessions:&emsp;</b>
            {item.num_accessions}
          </Col>
        </Row>
        <Row>
          <Col mdOffset={1}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} Reference
                  {rf_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
)
/*<Col sm={8}><b>Copy number in sequenced&nbsp;strain:&emsp;</b>{inlineBulletList(item.copy_number)}</Col>*/

FBte.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBti = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const al_s = item.num_alleles === 1 ? '' : 's'
    let al_dsbl = item.num_alleles > 0 ? '' : 'disabled'
    const st_s = item.num_stocks === 1 ? '' : 's'
    let st_dsbl = item.num_stocks > 0 ? '' : 'disabled'
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        <Row>
          <Col md={10} mdOffset={1}>
            <b>Sequence location(s):&emsp;</b>
            {expandArray(item.locations)}
          </Col>
        </Row>
        <Row>
          <Col smHidden={true} mdHidden={true} lgHidden={true}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + st_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBst'}>
                  {item.num_stocks} Stock
                  {st_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + al_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBal'}>
                  {item.num_alleles} Allele
                  {al_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col xsHidden={true} sm={2} mdOffset={1} md={2}>
            <a
              className={'btn btn-xs btn-lite ' + st_dsbl}
              href={'/hitlist/' + item.id + '/to/FBst'}>
              {item.num_stocks} Stock
              {st_s}
            </a>
          </Col>
          <Col xsHidden={true} sm={4} md={3}>
            <a
              className={'btn btn-xs btn-lite ' + al_dsbl}
              href={'/hitlist/' + item.id + '/to/FBal'}>
              {item.num_alleles} Allele
              {al_s}
            </a>
          </Col>
          <Col smHidden={true} md={2}>
            <b>Arm:&emsp;</b>
            {item.chromosome}
          </Col>
          <Col smHidden={true} md={4}>
            <b>Cytological&nbsp;Location:&emsp;</b>
            {item.cytology}
          </Col>
        </Row>
        <Row>
          <div className="visible-sm col-sm-4">
            <b>Arm:&emsp;</b>
            {item.chromosome}
          </div>
          <div className="visible-sm col-sm-6">
            <b>Cytological Location:&emsp;</b>
            {item.cytology}
          </div>
        </Row>
      </div>
    )
  }
)

FBti.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBto = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const cgot_s = item.num_common_gene_origin_related_tools === 1 ? '' : 's'
    const ot_s = item.num_other_related_tools === 1 ? '' : 's'
    const ct_s = item.num_compatible_tools === 1 ? '' : 's'
    const al_s = item.num_alleles === 1 ? '' : 's'
    const cn_s = item.num_constructs === 1 ? '' : 's'
    const in_s = item.num_insertions === 1 ? '' : 's'
    const us_s = Object.keys(item.uses).length === 1 ? '' : 's'

    const cgot_dsbl = item.num_common_gene_origin_related_tools
      ? ''
      : 'disabled'
    const ot_dsbl = item.num_other_related_tools ? '' : 'disabled'
    const ct_dsbl = item.num_compatible_tools ? '' : 'disabled'
    const al_dsbl = item.num_alleles ? '' : 'disabled'
    const cn_dsbl = item.num_constructs ? '' : 'disabled'
    const in_dsbl = item.num_insertions ? '' : 'disabled'

    const txt = item.name ? item.name + ' (' + item.id + ')' : item.id

    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          text={txt}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        <Row style={{ whiteSpace: 'nowrap' }}>
          <Col sm={10} mdOffset={1}>
            <b>
              Use
              {us_s}
              :&emsp;
            </b>
            {reportLinkHash(item.uses)}
          </Col>
        </Row>
        <Row style={{ paddingTop: 5 }}>
          <Col sm={12} md={10} mdOffset={1}>
            <SubTextCollapse
              label="Description"
              text={item.description}
              className="text-warning"
            />
          </Col>
        </Row>
        <Row style={{ whiteSpace: 'nowrap' }}>
          <Col
            xsHidden={true}
            smHidden={true}
            mdHidden={true}
            lg={4}
            lgOffset={1}>
            <a
              className={'btn btn-xs btn-lite ' + cgot_dsbl}
              href={
                '/hitlist/' + item.id + '/to/FBto?qualifier=originates_from'
              }>
              {item.num_common_gene_origin_related_tools} related tool
              {cgot_s} (common gene of origin)
            </a>
          </Col>
          <Col xsHidden={true} smHidden={true} mdHidden={true} lg={3}>
            <a
              className={'btn btn-xs btn-lite ' + ot_dsbl}
              href={'/hitlist/' + item.id + '/to/FBto?qualifier=related_tool'}>
              {item.num_other_related_tools} related tool
              {ot_s} (other)
            </a>
          </Col>
          <Col xsHidden={true} smHidden={true} mdHidden={true} lg={4}>
            <a
              className={'btn btn-xs btn-lite ' + ct_dsbl}
              href={
                '/hitlist/' + item.id + '/to/FBto?qualifier=compatible_tool'
              }>
              {item.num_compatible_tools} compatible tool
              {ct_s}
            </a>
          </Col>
        </Row>
        <Row style={{ whiteSpace: 'nowrap' }}>
          <Col
            xsHidden={true}
            smHidden={true}
            md={4}
            mdOffset={1}
            lgHidden={true}>
            <a
              className={'btn btn-xs btn-lite ' + cgot_dsbl}
              href={
                '/hitlist/' + item.id + '/to/FBto?qualifier=originates_from'
              }>
              {item.num_common_gene_origin_related_tools} related tool
              {cgot_s}
              <br />
              (common gene of origin)
            </a>
          </Col>
          <Col xsHidden={true} smHidden={true} md={3} lgHidden={true}>
            <a
              className={'btn btn-xs btn-lite ' + ot_dsbl}
              href={'/hitlist/' + item.id + '/to/FBto?qualifier=related_tool'}>
              {item.num_other_related_tools} related tool
              {ot_s}
              <br />
              (other)
            </a>
          </Col>
          <Col xsHidden={true} smHidden={true} md={4} lgHidden={true}>
            <a
              className={'btn btn-xs btn-lite ' + ct_dsbl}
              href={
                '/hitlist/' + item.id + '/to/FBto?qualifier=compatible_tool'
              }>
              {item.num_compatible_tools} compatible tool
              {ct_s}
            </a>
          </Col>
        </Row>
        <Row style={{ whiteSpace: 'nowrap' }}>
          <Col xsHidden={true} smHidden={true} md={4} mdOffset={1}>
            <a
              className={'btn btn-xs btn-lite ' + al_dsbl}
              href={'/hitlist/' + item.id + '/to/FBal'}>
              {item.num_alleles} Allele
              {al_s}
            </a>
          </Col>
          <Col xsHidden={true} smHidden={true} md={3}>
            <a
              className={'btn btn-xs btn-lite ' + cn_dsbl}
              href={'/hitlist/' + item.id + '/to/FBtp'}>
              {item.num_constructs} Construct
              {cn_s}
            </a>
          </Col>
          <Col xsHidden={true} smHidden={true} md={4}>
            <a
              className={'btn btn-xs btn-lite ' + in_dsbl}
              href={'/hitlist/' + item.id + '/to/FBin'}>
              {item.num_insertions} Insertion
              {in_s}
            </a>
          </Col>
        </Row>
        <Row>
          <Col mdHidden={true} lgHidden={true}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + cgot_dsbl}
                  href={
                    '/hitlist/' + item.id + '/to/FBto?qualifier=originates_from'
                  }>
                  {item.num_common_gene_origin_related_tools} related tool
                  {cgot_s}
                  <br />
                  (common gene of origin)
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + ot_dsbl}
                  href={
                    '/hitlist/' + item.id + '/to/FBto?qualifier=related_tool'
                  }>
                  {item.num_other_related_tools} related tool
                  {ot_s}
                  <br />
                  (other)
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + ct_dsbl}
                  href={
                    '/hitlist/' + item.id + '/to/FBto?qualifier=compatible_tool'
                  }>
                  {item.num_compatible_tools} compatible tool
                  {ct_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + al_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBal'}>
                  {item.num_alleles} Allele
                  {al_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + cn_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBpp'}>
                  {item.num_constructs} Construct
                  {cn_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + in_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBin'}>
                  {item.num_insertions} Insertion
                  {in_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
)

FBto.propTypes = {
  item: PropTypes.object.isRequired,
}

const CheckCol = styled(Col)`
  height: 2.5rem;
  display: flex;
  align-items: center;
`

const FBtp = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const al_s = Object.keys(item.associated_alleles).length === 1 ? '' : 's'
    const dc_s = '' // (Object.keys(item.collections).length===1) ? '' : 's';
    const in_s = item.num_insertions === 1 ? '' : 's'
    let in_dsbl = item.num_insertions > 0 ? '' : 'disabled'
    const st_s = item.num_stocks === 1 ? '' : 's'
    let st_dsbl = item.num_stocks > 0 ? '' : 'disabled'
    const rf_s = item.num_publications === 1 ? '' : 's'
    let rf_dsbl = item.num_publications > 0 ? '' : 'disabled'
    const hasExpression = item?.expression === '1'
    const hasImages = item?.images === '1'

    const uses_and_libraries_row = function () {
      let spacer, usesField, librariesField
//      if (item.uses != null) {
//        spacer = (
//          <Col xsHidden={true} smHidden={true} md={1}>
//            &nbsp;
//          </Col>
//        )
//        let sm = item.collections ? 6 : 12
//        let md = item.collections ? 5 : 10
//        usesField = (
//          <Col sm={sm} md={md}>
//            <b>Uses:&emsp;</b>
//            {expandArray(item.uses)}
//          </Col>
//        )
//      }
      if (item.collections) {
        spacer = (
          <Col xsHidden={true} smHidden={true} md={1}>
            &nbsp;
          </Col>
        )
        let sm = item.uses != null ? 6 : 12
        let md = item.uses != null ? 5 : 10
        librariesField = (
          <Col sm={sm} md={md}>
            <b>
              Dataset
              {dc_s}
              /Collection
              {dc_s}
              :&emsp;
            </b>
            {reportLinkHash(item.collections, false, true)}
          </Col>
        )
      }
      return (
        <Row>
          {spacer}
          {usesField}
          {librariesField}
        </Row>
      )
    }
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
        />
        <Row>
          <Col sm={6} md={5} mdOffset={1}>
            <b>
              Associated&nbsp;allele
              {al_s}
              :&emsp;
            </b>
            {reportLinkHash(item.associated_alleles)}
          </Col>
          <CheckCol sm={3}>
            <span style={{ fontWeight: 'bold', paddingRight: '0.75rem' }}>
              Expression Data:
            </span>
            <CheckCircle isChecked={hasExpression} />
          </CheckCol>
          <CheckCol sm={3}>
            <span style={{ fontWeight: 'bold', paddingRight: '0.75rem' }}>
              Image(s):
            </span>
            <CheckCircle isChecked={hasImages} />
          </CheckCol>
        </Row>
        {uses_and_libraries_row()}
        {/* buttons */}
        <Row>
          <Col xsHidden={true} sm={4} md={3} mdOffset={1}>
            <a
              className={'btn btn-xs btn-lite ' + in_dsbl}
              href={'/hitlist/' + item.id + '/to/FBti'}>
              {item.num_insertions} Associated Insertion
              {in_s}
            </a>
          </Col>
          <Col xsHidden={true} sm={3}>
            <a
              className={'btn btn-xs btn-lite ' + st_dsbl}
              href={'/hitlist/' + item.id + '/to/FBst'}>
              {item.num_stocks} Stock
              {st_s}
            </a>
          </Col>
          <Col xsHidden={true} sm={5}>
            <a
              className={'btn btn-xs btn-lite ' + rf_dsbl}
              href={'/hitlist/' + item.id + '/to/FBrf'}>
              {item.num_publications} Reference
              {rf_s}
            </a>
          </Col>
        </Row>
        <Row>
          <Col smHidden={true} mdHidden={true} lgHidden={true}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + in_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBti'}>
                  {item.num_insertions} Associated Insertion
                  {in_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + st_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBst'}>
                  {item.num_stocks} Stock
                  {st_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} Reference
                  {rf_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
)

FBtp.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBtr = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const cl_s = item.num_clones === 1 ? '' : 's'
    let cl_dsbl = item.num_clones > 0 ? '' : 'disabled'
    const rf_s = item.num_publications === 1 ? '' : 's'
    let rf_dsbl = item.num_publications > 0 ? '' : 'disabled'
    let tlist = [item.annotation_id, item.id]
    let pp =
      item.cds_length &&
      item.associated_polypeptide &&
      Object.keys(item.associated_polypeptide).length ? (
        <span>
          <b>Associated&nbsp;polypeptide:&emsp;</b>
          {reportLinkHash(item.associated_polypeptide)} ({item.cds_length} aa)
        </span>
      ) : (
        ''
      )
    return (
      <div>
        <ExpandedItemHitRow
          item={item}
          children={children}
          dataClassLabels={dataClassLabels}
          text={'(' + tlist.join(',&nbsp;') + ')'}
        />
        <Row>
          <Col sm={6} mdOffset={1} md={5}>
            <b>Feature&nbsp;type:&emsp;</b>
            {item.type}
          </Col>
          <Col sm={6}>
            <b>Associated&nbsp;gene:&emsp;</b>
            {reportLinkHash(item.associated_gene)}
          </Col>
        </Row>
        <Row>
          <Col sm={6} mdOffset={1} md={5}>
            <b>Transcript&nbsp;length (nt):&emsp;</b>
            {item.length}
          </Col>
          <Col sm={6}>{pp}</Col>
        </Row>
        <Row>
          <Col mdOffset={1}>
            <ul className="list-inline" style={{ margin: '0 10px' }}>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + cl_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBcl'}>
                  {item.num_clones}
                  &nbsp;Supporting&nbsp;clone
                  {cl_s}
                </a>
              </li>
              <li>
                <a
                  className={'btn btn-xs btn-lite ' + rf_dsbl}
                  href={'/hitlist/' + item.id + '/to/FBrf'}>
                  {item.num_publications} Reference
                  {rf_s}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    )
  }
)

FBtr.propTypes = {
  item: PropTypes.object.isRequired,
}

const FBxx = observer(
  ({ item, fields, dataClassLabels, children, ...props }) => {
    const li = fields.map((name) => (
      <li key={item.id + '_' + name}>
        <b>
          {name}
          :&emsp;
        </b>{' '}
        {item[name]}
      </li>
    ))
    return (
      <div>
        <Row>
          <Col xs={12}>
            {children}
            <b>unclassified</b>
          </Col>
        </Row>
        <hr />
        <ul className="list-inline">{li}</ul>
      </div>
    )
  }
)

FBxx.propTypes = {
  item: PropTypes.object.isRequired,
}

function ExpandedItems({ item, store, dataClassLabels, children, ...props }) {
  const fields = Object.keys(item)

  let Item

  switch (item.data_type) {
    case 'FBab':
      Item = FBab
      break
    case 'FBal':
      Item = FBal
      break
    case 'FBba':
      Item = FBba
      break
    case 'FBcl':
      Item = FBcl
      break
    case 'FBch':
      Item = FBch
      break
    case 'FBco':
      Item = FBco
      break
    case 'FBgg':
      Item = FBgg
      break
    case 'FBgn':
      Item = FBgn
      break
    case 'FBhh':
      Item = FBhh
      break
    case 'FBig':
      Item = FBig
      break
    case 'FBim':
      Item = FBim
      break
    case 'FBlc':
      Item = FBlc
      break
    case 'FBpp':
      Item = FBpp
      break
    case 'FBrf':
      Item = FBrf
      break
    case 'FBsf':
      Item = FBsf
      break
    case 'FBsn':
      Item = FBsn
      break
    case 'FBst':
      Item = FBst
      break
    case 'FBtc':
      Item = FBtc
      break
    case 'FBte':
      Item = FBte
      break
    case 'FBti':
      Item = FBti
      break
    case 'FBmc':
    case 'FBms':
    case 'FBtp':
      Item = FBtp
      break
    case 'FBto':
      Item = FBto
      break
    case 'FBtr':
      Item = FBtr
      break
    case 'FBcv':
    case 'FBsv':
    case 'FBdv':
    case 'FBbi':
    case 'FBbt':
    case 'DOID':
    case 'MI':
    case 'GO':
    case 'SO':
    case 'CHEBI':
      Item = CVterm
      break
    default:
      Item = FBxx
      break
  }

  return (
    <ItemPanel key={item.id + '_panel'} className="itemPanel">
      <Item fields={fields} item={toJS(item)} dataClassLabels={dataClassLabels}>
        {children}
      </Item>
    </ItemPanel>
  )
}

ExpandedItems.propTypes = {
  item: PropTypes.object.isRequired,
  dataClassLabels: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
}

export default observer(ExpandedItems)
